module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img_center"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/page_014.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "hrightt"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("This bib is sweet and bright like its namesake fruit, and it is even worked in “segments.” Decreases are worked at the edges of each segment, bringing each one to a point.")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("FINISHED MEASUREMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("9½ (11)\" diameter at widest point")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("YARN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Berroco Comfort Chunky (50% super fine nylon / 50% super fine acrylic; 100 grams / 150 yards): 1 skein #5724 Pumpkin")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("NEEDLES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("One pair straight needles size US 10½ (6.5 mm)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Change needle size if necessary to obtain correct gauge.")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("NOTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Stitch markers")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("GAUGE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("14 sts and 20 rows = 4\" (10 cm) in Stockinette stitch (St st)")])]), _vm._v(" "), _c('p', {
    staticClass: "sh1t"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("BIB")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Using Long-Tail CO (see Special Techniques, page 156), CO 86 (100) sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 1 (RS):")]), _vm._v(" K1, [k2tog, k8 (10) sts, ssk, pm] 7 times, k1—72 (86) sts remain. Knit 5 rows.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 2 (RS):")]), _vm._v(" Change to St st. Decrease 14 sts this row, then every 4 rows 3 (4) times, as follows: K1, [k2tog, knit to 2 sts before marker, ssk, sm] 7 times, k1—16 sts remain. Work even for 3 rows, removing markers.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 3 (RS):")]), _vm._v(" K1, [k2tog] 7 times, k1—9 sts remain. Work even for 1 row.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Decrease Row 4 (RS):")]), _vm._v(" [K3tog] 3 times—3 sts remain. BO all sts.")]), _vm._v(" "), _c('p', {
    staticClass: "sh1"
  }, [_c('span', {
    staticClass: "litbrown"
  }, [_vm._v("TIE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Using Knitted or Cable CO (see Special Techniques, page 156), CO 34 (40) sts, turn so that CO sts are on right-hand needle. With RS of Bib facing, pick up and knit 1 st at corner of CO edge and right side edge, pass next st (last CO st) over picked-up st, pick up and knit 33 (39) sts along side edge, BO edge, then other side edge, turn—67 (79) sts.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('b', [_vm._v("Next Row:")]), _vm._v(" Using Knitted or Cable CO, CO 33 (39) sts, knit to end—100 (118) sts. BO all sts purlwise.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f74ec18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter03.vue
// module id = 78
// module chunks = 0